import { render, staticRenderFns } from "./uploads.vue?vue&type=template&id=b5d06b90&scoped=true"
import script from "./uploads.vue?vue&type=script&lang=js"
export * from "./uploads.vue?vue&type=script&lang=js"
import style0 from "./uploads.vue?vue&type=style&index=0&id=b5d06b90&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d06b90",
  null
  
)

export default component.exports